const StatusEnum = {
    Active: 1,
    Passive: 2,
    Deleted: 3,
}

export default StatusEnum